<template>
<div>
  <div style="margin-bottom: 5px;">
    <el-button size="mini" type="primary" @click="setData">保存</el-button>
    <el-button size="mini" type="primary" v-if="mainObj.id&&form.ProcessState==0" @click="startFlow">装修申请</el-button>
<!--    <el-button size="mini" type="warning" v-if="mainObj.id&&form.ProcessState>0&&form.ProcessState!=5&&form.ProcessState!=6" @click="cancelSure()">取消装修</el-button>-->
    <el-button size="mini" @click="setComponentId('FurnishList')">返回</el-button>
  </div>
  <div>
    <el-row>
      <el-col :span="12">
        <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
          <el-descriptions-item label="房号">
            <el-input size="mini" v-model="form.house_name" readonly></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="业主名称">
            <el-input size="mini" v-model="form.customer_name" readonly></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="装修编号">
<!--            <el-input size="mini" v-model="form.FitmentID"></el-input>-->
            <el-row>
              <el-col :span="16">
                <el-input size="mini" class="form-input" v-model="form.FitmentID" clearable autocomplete="off"></el-input>
              </el-col>
              <el-col :span="8">
                <el-button v-if="!form.FitmentID" size="mini" @click="getFitmentNumber('ZX',form.HouseID,'FitmentID')">获取</el-button><span style="color: red;margin-top: 5px;">*</span>
              </el-col>
            </el-row>
          </el-descriptions-item>
          <el-descriptions-item label="装修时间">
            <el-col :span="11">
              <el-date-picker size="mini" type="date" placeholder="开始时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.BeginDate" style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker size="mini" type="date" placeholder="结束时间" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.EndDate" style="width: 100%;"></el-date-picker>
            </el-col>
          </el-descriptions-item>
          <el-descriptions-item label="备案证编号">
            <el-input size="mini" v-model="form.ForRecordNo"></el-input>
<!--            <el-row>-->
<!--              <el-col :span="16">-->
<!--                <el-input size="mini" class="form-input" v-model="form.ForRecordNo" clearable autocomplete="off"></el-input>-->
<!--              </el-col>-->
<!--              <el-col :span="8">-->
<!--                <el-button v-if="!form.ForRecordNo" size="mini" @click="getFitmentNumber('ZXBA',form.HouseID,'ForRecordNo')">获取</el-button><span style="color: red;margin-top: 5px;">*</span>-->
<!--              </el-col>-->
<!--            </el-row>-->
          </el-descriptions-item>
          <el-descriptions-item label="装修内容">
            <el-input size="mini" type="textarea" :rows="3" v-model="form.AskFitment"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="结构是否改动">
            <el-radio v-model="form.StructIsChange" :label="0">否</el-radio>
            <el-radio v-model="form.StructIsChange" :label="1">是</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="有否违法装修">
            <el-radio v-model="form.IsIllegal" :label="0">否</el-radio>
            <el-radio v-model="form.IsIllegal" :label="1">是</el-radio>
          </el-descriptions-item>
          <el-descriptions-item label="施工人数">
            <el-input size="mini" v-model="form.StaffCount"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户现场负责人">
            <el-input size="mini" v-model="form.FaceTakeChargeBy"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="物业意见">
            <el-input size="mini" type="textarea" :rows="3" v-model="form.ConfirmOpinion"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="验收人">
            <el-input size="mini" v-model="form.CheckName"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="验收说明">
            <el-input size="mini" type="textarea" :rows="3" v-model="form.CheckRemark"></el-input>
          </el-descriptions-item>
        </el-descriptions>


      </el-col>
      <el-col :span="12">
        <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
          <el-descriptions-item label="租户名称">
            <el-input size="mini" v-model="form.rent_customer_name" readonly></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="申请时间">
            <el-date-picker size="mini" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.ApplyDate" style="width: 100%;"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="装修批准日期">
            <el-date-picker size="mini" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.AuditDate" style="width: 100%;"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="备案日期">
            <el-date-picker size="mini" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.ForRecordDate" style="width: 100%;"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="责任人">
            <el-input size="mini" v-model="form.TakeChargeBy"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="审批人">
            <el-input size="mini" v-model="form.ApproveBy"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="审批单编号">
            <el-input size="mini" v-model="form.CheckBillNo"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="违法装修处理结果">
            <el-input size="mini" v-model="form.IsIllegalResult"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="住宿人数">
            <el-input size="mini" v-model="form.StaffCountOvernight"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <el-input size="mini" v-model="form.FaceTakeChargeByPhone"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="政府主管部门意见">
            <el-input size="mini" type="textarea" :rows="3" v-model="form.FireOpinion"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="验收时间">
            <el-date-picker size="mini" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="form.CheckDate" style="width: 100%;"></el-date-picker>
          </el-descriptions-item>

          <el-descriptions-item label="取消原因">
            <el-input size="mini" v-model="form.CancelCause"></el-input>
          </el-descriptions-item>
        </el-descriptions>

      </el-col>
    </el-row>
    <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
      <el-descriptions-item label="装修状态">
        <el-radio-group size="mini" v-model="form.ProcessState" placeholder="请选择">
          <el-radio
            :disabled="index<2"
            v-for="(item,index) in status_list"
            :key="item.value"
            :label="item.value">
            {{item.name}}
          </el-radio>
        </el-radio-group>
      </el-descriptions-item>
      <el-descriptions-item label="装修单位">
        <el-row>
          <el-col :span="12">
            <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
              <el-descriptions-item label="名称">
                <el-input size="mini" v-model="form.CompanyID"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="营业执照">
                <el-input size="mini" v-model="form.CompanyLicenseNo"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="资质等级">
                <el-input size="mini" v-model="form.CompanyLevel"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="备案证号">
                <el-input size="mini" v-model="form.CompanyRecordNO"></el-input>
              </el-descriptions-item>
            </el-descriptions>

          </el-col>
          <el-col :span="12">
            <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
              <el-descriptions-item label="负责人">
                <el-input size="mini" v-model="form.CompanyMaster"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="身份证号码">
                <el-input size="mini" v-model="form.CompanyMasterIDCard"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="联系电话">
                <el-input size="mini" v-model="form.CompanyMasterPhone"></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="手机">
                <el-input size="mini" v-model="form.CompanyMasterMobilePhone"></el-input>
              </el-descriptions-item>
            </el-descriptions>

          </el-col>
        </el-row>
      </el-descriptions-item>
      <el-descriptions-item label="附件">

      </el-descriptions-item>
      <el-descriptions-item>
        <!--      <el-button type="primary" @click="setData">保存</el-button>-->
      </el-descriptions-item>
    </el-descriptions>
  </div>
</div>
</template>
<script>
import UploadFileFJ from "../../UploadFileFJ";

export default {
  name: "FurnishEditor",
  components: {UploadFileFJ},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      status_list:[
        {name:"未审批",value:'0'},
        {name:"审批中",value:'1'},
        {name:"已审批",value:'2'},
        {name:"已缴费",value:'3'},
        {name:"已入场",value:'4'},
        {name:"已取消",value:'5'},
        {name:"已完成",value:'6'},
      ],
      form:{}
    }
  },
  activated() {
    this.getData()
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          // that.ProcessState=ret.data.ProcessState
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setData(){
      const that = this;
      if(!that.form.HouseID){
        that.form.HouseID=that.mainObj.house_id;
      }
      ERP.postRequest({url:"admin/HouseFurnish/setFurnish",data:that.form},ret=>{
        if(ret.code){
          that.mainObj.id=ret.data.ID;
          that.form.ID=ret.data.ID;
          that.$msgbox.alert(ret.msg||"修改成功")
        }else{
          that.$msgbox.alert(ret.msg||"修改失败")
        }
      })
    },
    startFlow(){
      const that=this;
      let timeValue=(new Date()).getTime();
      ERP.navigateTo(`/flow/FlowView?sheet_id=12&master_id=80&house_id=${that.form.HouseID}&fitment_id=${that.form.ID}&timeValue=${timeValue}`)
    },
    UploadFileFJSuccess(list){
      this.form.appendix=list;
    },
    getFitmentNumber(top,house_id,value){
      const that=this;
      ERP.getRequest({url:"admin/HouseFurnish/getFitmentNumber",data:{top:top,house_id:house_id} },ret=>{
        if(ret.code){
          that.form[value]=ret.data;
        }else{
          that.$msgbox.alert(ret.msg||"获取失败")
        }
      })
    },
    cancelSure() {
      const that = this;
      if(that.mainObj.id != '') {
        this.$confirm('是否取消, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ERP.postRequest({url:"admin/HouseFurnish/setProcessState",data:{id:that.mainObj.id,ProcessState:5}},ret=>{
            if(ret.code){
              this.$msgbox.alert(ret.msg||"操作成功")
              that.ProcessState = 3
            }else{
              this.$msgbox.alert(ret.msg||"查询失败")
            }
          })

        }).catch(() => {
          // this.$message({type: 'info',message: '已取消'});
        });
      }
    },
  },
  watch:{

  }

}
</script>

<style lang="scss" scoped>
@import url(../../common.scss);
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishEditor.vue